import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledHeaderFilter = styled(Box, {
  alignContent: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$4',
});

export const StyledSelectedRange = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
  padding: '$4 $0',
});

export const StyledDate = styled(Box, {
  fontWeight: '$bold',
  lineHeight: '$6',
  marginLeft: '$4',
});
